module.exports = __webpack_public_path__ + "static/media/health.a34900b9.png";